module.exports = __webpack_public_path__ + "static/Scindo_round_summary-bf053bc167086a47263d09c62d7276a5.png";